import { Users } from "lucide-react";
import { COMMUNITY_REWARDS } from "../../data/site";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

export const CommunityRewards = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="community-rewards-section" className="border-t border-white/5 bg-nx-base py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <SectionHeader
                    label={t("Support System")}
                    testId="community-rewards"
                    title={<>{t("Rewards for")}<br />{t("Community Growth")}</>}
                    description={t("One-time bonuses from the Support System when community milestones are reached.")}
                />
                <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3 lg:gap-5">
                    {COMMUNITY_REWARDS.map((r, i) => (
                        <Reveal key={r.bonus} delay={i * 0.1}>
                            <div
                                className={`group h-full rounded-2xl border p-7 transition-all duration-300 hover:-translate-y-1 lg:p-8 ${
                                    i === 2
                                        ? "border-nx-lime/25 bg-nx-lime/[0.05] hover:border-nx-lime/40"
                                        : "border-white/5 bg-nx-elev hover:border-white/10"
                                }`}
                                data-testid={`reward-milestone-${i + 1}`}
                            >
                                <div className="flex items-center gap-2 text-nx-mute">
                                    <Users size={14} strokeWidth={1.5} aria-hidden="true" />
                                    <span className="text-[11px] font-bold uppercase tracking-[0.16em]">{t(r.partners)} &bull; {t(r.team)}</span>
                                </div>
                                <span className={`mt-5 block text-5xl font-extrabold tracking-tight tabular ${i === 2 ? "text-nx-lime" : "text-nx-text"}`}>
                                    {r.bonus}
                                </span>
                                <span className="mt-2 block text-[11px] font-bold uppercase tracking-[0.18em] text-nx-mute">{t("One-Time Bonus")}</span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
